import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ContactPanel } from '../../../feedback';
import AboutUsSkeleton from '../components/AboutUsSkeleton';
import { useAboutUs } from '../hooks/useAboutUs';
import './AboutUsPage.scss';

function isUkrainian(language: string | undefined) {
  return (language || '').toLowerCase().startsWith('ua');
}

const AboutUsPage = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { body, isLoading } = useAboutUs();
  const html = isUkrainian(i18n.language) ? body.ua : body.en;

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (location.hash !== '#contacts') {
      return;
    }
    const el = document.getElementById('contacts');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [isLoading, location.hash, location.pathname]);

  if (isLoading) {
    return <AboutUsSkeleton />;
  }

  const hasHtml = Boolean(
    html
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim(),
  );

  return (
    <div className="about-us-page">
      {hasHtml ? (
        <section className="about-us">
          <h1 className="about-us__title">
            {t('header.navigation.about-us')}
          </h1>
          <div
            className="about-us__body"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </section>
      ) : null}
      <ContactPanel />
    </div>
  );
};

export default AboutUsPage;
